import React, { useState } from "react";
import { Alert, Button, Container } from "react-bootstrap";
import { HeadquartersList } from "../components/HeadquartersList";
import { HeadquartersForm } from "../components/HeadquartersForm";
import { HeadquartersAccessModal } from "../components/HeadquartersAccessModal";
import { usePlanLimits } from "../hooks/usePlanLimits";

function SedesPage() {
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [showLimitAlert, setShowLimitAlert] = useState(false);
  const [accessHqId, setAccessHqId] = useState(null);

  const { data: limits } = usePlanLimits();
  const hqLimit = limits?.headquarters;
  const atLimit = hqLimit?.allowed === false;

  const openNew = () => {
    if (atLimit) {
      setShowLimitAlert(true);
      return;
    }
    setShowLimitAlert(false);
    setEditing(null);
    setShowForm(true);
  };

  const openEdit = (hq) => {
    setEditing(hq);
    setShowForm(true);
  };

  const handleHide = () => {
    setShowForm(false);
    setEditing(null);
  };

  return (
    <Container fluid className="py-3">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <div>
          <h4 className="mb-0">Sedes</h4>
          {hqLimit && (
            <small className="text-muted">
              {hqLimit.used} / {hqLimit.limit ?? "∞"} sede{hqLimit.limit !== 1 ? "s" : ""} usada{hqLimit.used !== 1 ? "s" : ""}
            </small>
          )}
        </div>
        <Button
          variant={atLimit ? "outline-secondary" : "primary"}
          onClick={openNew}
          style={{ minHeight: 44 }}
        >
          + Nueva sede
        </Button>
      </div>

      {showLimitAlert && hqLimit && (
        <Alert
          variant="warning"
          dismissible
          onClose={() => setShowLimitAlert(false)}
          className="mb-3"
        >
          <Alert.Heading className="h6">Límite de sedes alcanzado</Alert.Heading>
          Tu plan permite hasta <strong>{hqLimit.limit} sede{hqLimit.limit !== 1 ? "s" : ""}</strong>.{" "}
          {hqLimit.suggest_upgrade
            ? "Con el costo actual de bloques de capacidad, mejorar tu plan puede ser más económico."
            : "Contacta a soporte o actualiza tu plan para agregar más sedes."}
        </Alert>
      )}

      <HeadquartersList
        onEdit={openEdit}
        onManageAccess={(hq) => setAccessHqId(hq.id)}
      />

      <HeadquartersForm
        show={showForm}
        onHide={handleHide}
        editing={editing}
      />

      <HeadquartersAccessModal
        show={accessHqId != null}
        onHide={() => setAccessHqId(null)}
        hqId={accessHqId}
      />
    </Container>
  );
}

export { SedesPage };
